module.exports = __webpack_public_path__ + "img/Beta Digitis - Gif 2_2-414.e3801568.png";